import { IdType, SharingData } from '../../schema/SharingData';
import { SharingTipId } from '../../types/sharingTipId';
import { getExpirationCustomActions } from '../getExpirationCustomActions';
import { assertNever } from 'owa-assert';
import { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export function getCustomActions(
    sharingData: SharingData[],
    sharingTipId: SharingTipId,
    convertCloudyToClassicAction?: (id: IdType) => InfoBarCustomAction
): InfoBarCustomAction[] | null {
    if (sharingData.length !== 1 || convertCloudyToClassicAction === null) {
        return null;
    }

    switch (sharingTipId) {
        case SharingTipId.noPermissionToShare:
        case SharingTipId.noPermissionToShareExternally:
        case SharingTipId.externalRecipientCSL:
        case SharingTipId.sharingWithLargeDL:
            return sharingData[0].supportsDownsell
                ? [convertCloudyToClassicAction(sharingData[0].id)]
                : null;
        case SharingTipId.getSharingInfoFailed:
        case SharingTipId.noPermissionSet:
            return null;
        case SharingTipId.linkHasExpired:
        case SharingTipId.linkWillExpire:
            return getExpirationCustomActions(sharingData[0]);
        default:
            return assertNever(sharingTipId);
    }
}
